import type { AppointmentSlot } from '~/models/appointmentSlot'
import type {
  POSTAppointmentBooking,
  TerminalName,
} from '~/services/apiClient/api'
import { TERMINALS_WITH_OWN_CHASSIS_OPTION_FOR_IMPORT_APPT } from '~/constants'

export interface CreateBookingPayloadParams {
  slot: AppointmentSlot
  containerNumber: string
  terminal: TerminalName
  masterBL?: string
  licensePlate?: string
  ownChassis?: boolean
  existingAppointmentId?: number
}

/**
 * Creates a standardized booking payload for appointment booking API requests.
 * Automatically includes the own_chassis field ONLY for terminals that support it.
 */
export function createBookingPayload({
  slot,
  containerNumber,
  terminal,
  masterBL,
  licensePlate,
  ownChassis,
  existingAppointmentId,
}: CreateBookingPayloadParams): POSTAppointmentBooking {
  const payload: POSTAppointmentBooking = {
    slot: {
      window_start: slot.window_start.toUTC().toISO(),
      terminal,
      container_number: containerNumber,
      from_terminal_block_availability_key:
        slot.from_terminal_block_availability_key,
      observed: slot.observed.toUTC().toISO(),
    },
    master_bill_of_lading: masterBL,
    truck_license_plate: licensePlate,
    existing_appointment_id_to_cancel: existingAppointmentId,
  }

  // Only include own_chassis field for terminals that support it
  if (TERMINALS_WITH_OWN_CHASSIS_OPTION_FOR_IMPORT_APPT.has(terminal)) {
    payload.own_chassis = ownChassis
  }

  return payload
}
